<app-input-label [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText"></app-input-label>

<input
  [id]="id"
  [name]="name"
  class="input"
  [class.invalid]="isInvalid"
  [type]="month? 'month': 'date'"
  [disabled]="isDisabled"
  [(ngModel)]="value"
  [mask]="mascara()"
  max="9999-12-31"
  (blur)="onBlur()"
  (input)="handleInput()"
  #inputData
>
  
